// import { Security } from "@mui/icons-material";
// import sandwich from "../../images/sunkIcon/1-sandwich.png";
// import football from "../../images/sunkIcon/2-football.png";
// import Grass from "../../images/sunkIcon/3-Grass.png";
// import Kindergarten from "../../images/sunkIcon/4-Kindergarten.png";
// import Firefox from "../../images/sunkIcon/5-Firefox.png";
// import Sunset from "../../images/sunkIcon/6-Sunset.png";
// import Guacamole from "../../images/sunkIcon/7-Guacamole.png";
// import things from "../../images/sunkIcon/8-Stranger-things.png";
// import Beach from "../../images/sunkIcon/9-Beach.png";

const questions = [
  {
    id: 1,
    title: "U.S. Tax Revenues (2025)",
    desc: "",
    boldText: "",
    answer: "Private Good",
    actual: {
      IndividualIncome: 51,
      CorporateIncome: 9,
      PayrollTax: 33,
      CustomsDuties: 4,
      ExciseTax: 2,
      Other: 1,
    },
    tooltip:{
      IndividualIncome: "A tax on the income of individuals, including wages, salaries, and other earnings.",
      CorporateIncome: "Corporate Income Tax: A tax imposed on the profits of corporations.",
      PayrollTax: "A tax on wages that employers and employees contribute to fund Social Security and Medicare.",
      CustomsDuties: "A tax on imported goods, such as cars, electronics, and clothing.",
      ExciseTax: "A tax on specific goods, such as alcohol, tobacco, and gasoline, often included in the price of the product.",
      Other: "Other taxes not included above.",
    },
    description: "You will notice the primary sources of U.S. government revenue are individual income taxes, payroll taxes, and corporate income taxes. Of these three, the bulk are taxes on workers' labor in the form of individual income taxes and payroll taxes.",
    wrongAnswerText: "",
    rightAnswerText:"",
  },
];

export default questions;
